import React, { useState } from 'react';
import Order from './Order';
import Receipt from './Receipt';
import ValidatePayment from './ValidatePayment';
import { PaymentCallBackProps } from '../types/PaymentCallBackProps';
import { ReceiptProps } from '../types/ReceiptProps';

interface ClubSalesProps {
  readonly clubData: any;
  readonly stripeData: any;
}

function ClubSales({ clubData, stripeData }: ClubSalesProps) {
  const { campaign } = clubData;
  return (
    <>
      <div className="image">
        <img
          src={campaign?.image || 'https://www.golfamore.com/assets/img/club-sales/general-banner.jpg'}
          id="campaign-img"
          alt="golfamore"
        />
        {/* <div className="center">
          <h1>Golfamore = Golfamore</h1>
        </div> */}
      </div>
      <Switch clubData={clubData} stripeData={stripeData} />
    </>
  );
}

function Switch({ clubData, stripeData }: ClubSalesProps) {
  const [receiptData, setReceiptData] = useState(null);

  const paymentValidationCallback = (data: PaymentCallBackProps) => {
    if (data.status === 'PAID') {
      setReceiptData(data.payment);
    }
  };

  const validatePayment = !!stripeData && stripeData.status === 'success';
  const paymentCanceled = stripeData?.status === 'canceled';
  const showReceipt = !!receiptData;

  switch (true) {
    case showReceipt:
      return <Receipt clubData={clubData} receiptData={receiptData} />;
    case validatePayment:
      return <ValidatePayment stripeData={stripeData} callback={paymentValidationCallback} />;
    default:
      return (
        <Order
          clubData={clubData}
          callback={(data: ReceiptProps) => setReceiptData(data)}
          paymentCanceled={paymentCanceled}
        />
      );
  }
}

export default ClubSales;
